App.prototype.currencyWidget = function () {

    const $widgets = $('[data-currency-widget]');

    if ($widgets.length) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://paracevirici.com/servis/widget/widget.js';

        document.body.appendChild(script);

        script.onload = function () {
            $.each($widgets, function (key, el) {
                const $el = $(el);
                const options = $el.data('currencyWidgetOptions');
                if (options.is_top_of_header){
                    typeof $.fn.paraceviriciWidget == "function" &&
                    $el.paraceviriciWidget({
                        widget:"slideline",
                        wData:{
                            category:0,
                            currency:Object.keys(options.currencies)
                                .filter(k => options.currencies[k] === "1")
                                .join("-")
                        },
                        wSize:{
                            wWidth:"100%",
                            wHeight:30
                        }
                    });
                }

            });
        }
    }

};

App.prototype.currencyWidget();
